import { createAction } from '@reduxjs/toolkit';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { toast } from 'react-toastify';
import api from '../../utils/api';

export const receiveUsers = createAction('users/receive');

export function receiveUsersActionCreator(users) {
  return receiveUsers({ users });
}

export function asyncRegisterUser({ name, email, password }) {
  return async (dispatch) => {
    let isSuccess;
    dispatch(showLoading());
    try {
      await api.register({ name, email, password });
      toast.success('User created successfully');
      isSuccess = true;
    } catch (error) {
      toast.error(error.message);
      isSuccess = false;
    }
    dispatch(hideLoading());
    return isSuccess;
  };
}
